/**
 * Erreurs applicatives, telles que l'API les renvoie.
 *
 * Le code métier (`GRV_NOT_FOUND`, `FORBIDDEN`…) est stable et documenté au contrat ; le message est
 * en français et destiné à être affiché tel quel (`docs/agent-spec/05-api-backend.md`). Le frontend
 * ne réécrit donc pas les messages du serveur : il les montre.
 */
export type CodeErreur =
  | "VALIDATION_ERROR"
  | "UNAUTHENTICATED"
  | "FORBIDDEN"
  | "GRV_NOT_FOUND"
  | "CONFLICT"
  | "RATE_LIMITED"
  | "INTERNAL_ERROR";

export type DetailValidation = { field?: string; issue?: string };

export class ErreurApi extends Error {
  constructor(
    readonly statut: number,
    readonly code: CodeErreur | string,
    message: string,
    readonly details: DetailValidation[] = [],
  ) {
    super(message);
    this.name = "ErreurApi";
  }

  /** Vrai si l'erreur porte sur ce que l'utilisateur a saisi, et non sur un problème technique. */
  get estUneErreurDeSaisie(): boolean {
    return this.code === "VALIDATION_ERROR" || this.code === "CONFLICT";
  }

  /**
   * Messages par champ, pour les afficher à côté du champ concerné plutôt qu'en bandeau
   * (`docs/agent-spec/20-formulaires.md`).
   */
  get parChamp(): Record<string, string> {
    const resultat: Record<string, string> = {};
    for (const detail of this.details) {
      if (detail.field && detail.issue) resultat[detail.field] = detail.issue;
    }
    return resultat;
  }
}

/**
 * Message à afficher pour une erreur inattendue. Volontairement sobre : le serveur ne renvoie jamais
 * de détail d'implémentation, et en inventer un côté client serait trompeur.
 */
export const MESSAGE_INDISPONIBLE =
  "Le service est momentanément indisponible. Merci de réessayer dans quelques instants.";
